import { useParams } from 'react-router-dom';

import AuditHistoryAccordion from './AuditHistoryAccordion';
import Layout from './Layout';
import { useGetAssetReconciliationAudit } from './hooks';

export default function AssetReconciliationAuditHistory() {
  const {
    data: auditHistory,
    isLoading,
    isError,
  } = useGetAssetReconciliationAudit();

  const { pageEnum } = useParams();

  return (
    <Layout
      pageEnum={pageEnum}
      isLoading={isLoading}
      isError={isError}
      isDataEmpty={!auditHistory?.length}
    >
      <AuditHistoryAccordion data={auditHistory} />
    </Layout>
  );
}
